import { Dispatch } from "react";
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import { IFilter } from ".";
import APIS from "../../constant/Endpoint";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import DateRangePicker from "../Reusable/DateRangePicker";
import { ClientAccessControl } from "@careinfo/permission-required";
import usePermission from "../../customHooks/usePermission";

interface Props {
  register: UseFormRegister<IFilter>;
  setValue: UseFormSetValue<IFilter>;
  getValues: UseFormGetValues<IFilter>;
  clearErrors: UseFormClearErrors<IFilter>;
  errors: FieldErrors<IFilter>;
  control: Control<IFilter, any>;
  setDate: Dispatch<any>;
  adminOnly: boolean;
}

const InternationalFilter = ({
  setValue,
  getValues,
  setDate,
  control,
}: Props) => {
  const isStaffFilter = usePermission({
    allowedPermissions: ["can_filter_by_staff"],
  });
  const isDestinationFilter = usePermission({
    allowedPermissions: ["can_filter_by_destination"],
  });
  const isBranchFilter = usePermission({
    allowedPermissions: ["can_filter_by_branch"],
  });
  const isSenderFilter = usePermission({
    allowedPermissions: ["can_filter_by_sender"],
  });
  const isClientFilter = usePermission({
    allowedPermissions: ["can_filter_by_client"],
  });
  const isDateFilter = usePermission({
    allowedPermissions: ["can_filter_by_date_range"],
  });

  console.log(isStaffFilter);
  return (
    <>
      <ClientAccessControl
        allowedPermissions={["can_edit_overview_filter"]}
        renderNoAccess={<></>}
      >
        <ComboboxFilter<IFilter>
          url={APIS.BRANCH}
          disabled={!isBranchFilter}
          queryKey={"branch"}
          name={"pickup_branch"}
          control={control}
          label={"Branch"}
          params={{
            is_active: true,
          }}
          placeholder={"Select Branch"}
        />
        {/* <ComboboxFilter<IFilter>
              url={APIS.BRANCH}
              disabled={true}
              queryKey={'to-branch'}
              name={'to_branch'}
              control={control}
              label={'To Branch'}
              params={{
                is_active: true,
              }}
              placeholder={'Select Branch'}
            /> */}
        <ComboboxFilter<IFilter>
          url={APIS.LOCATION}
          disabled={!isDestinationFilter}
          queryKey={"country"}
          params={{ level: 0, is_active: true }}
          name={"receiver_country"}
          control={control}
          label={"Destination"}
          placeholder={"Select Destination "}
        />
        <ComboboxFilter<IFilter>
          url={APIS.STAFF}
          disabled={!isStaffFilter}
          queryKey={"staff"}
          params={{ is_staff: true, is_active: true }}
          name={"staff"}
          control={control}
          label={"Staff"}
          placeholder={"Select Staff"}
        />
        <ComboboxFilter<IFilter>
          url={APIS.CUSTOMER}
          disabled={!isSenderFilter}
          queryKey={"customer"}
          name={"sender"}
          control={control}
          label={"Sender"}
          params={{
            is_active: true,
          }}
          placeholder={"Select Sender"}
        />
        <ComboboxFilter<IFilter>
          url={APIS.MERCHANT}
          disabled={!isClientFilter}
          queryKey={"vendor"}
          name={"vendor"}
          control={control}
          label={"Client"}
          params={{
            is_active: true,
          }}
          placeholder={"Select client"}
        />
        <DateRangePicker
          label={"Select Date Range"}
          setValue={setValue}
          name={"date_range"}
          disabled={!isDateFilter}
          getValues={getValues}
          setDate={setDate}
        />
      </ClientAccessControl>
    </>
  );
};

export default InternationalFilter;
